<template>
  <div>
    <div class="app-intro-content">
      <h1 class="app-title" v-html="md(copy.headline)"></h1>
      <div class="app-subhed" v-html="md(copy.subhed)"></div>
      <div class="byline-wrapper">
        <div class="byline" v-html="md(copy.byline)"></div>
        <div class="date">Published {{ publishDate }}, Updated {{ updatedDate }}</div>
      </div>
      <div class="social-container">
        <a class="social-button" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Fprojects.chalkbeat.org%2Flocal-school-councils%2Findex.html%23%2F&amp;src=sdkpreparse">
          <div class="social-icon-container">
            <svg version="1.1" id="icon-facebook" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
            	 y="0px" viewBox="0 0 9.2 19" style="enable-background:new 0 0 9.2 19;" xml:space="preserve">
            <path d="M2.4,19v-8.9H0V6.9h2.4V4.1C2.4,2,3.7,0,7,0c1.3,0,2.3,0.1,2.3,0.1l-0.1,3c0,0-1,0-2,0c-1.2,0-1.3,0.5-1.3,1.4v2.3h3.5
            	l-0.2,3.2H5.8V19L2.4,19L2.4,19z"/>
            </svg>
          </div>
        </a>
        <a class="social-button" href="https://twitter.com/intent/tweet?text=Friday%20is%20the%20deadline%20to%20run%20for%20Chicago%27s%20school%20councils.%20What%20to%20know%20http://projects.chalkbeat.org/local-school-councils/index.html#/">
          <div class="social-icon-container">
            <svg version="1.1" id="icon-twitter" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
            	 y="0px" viewBox="0 0 21 17" style="enable-background:new 0 0 21 17;" xml:space="preserve">
            <path d="M21,2c-0.8,0.3-1.6,0.6-2.5,0.7c0.9-0.5,1.6-1.4,1.9-2.4c-0.8,0.5-1.8,0.9-2.7,1C16.9,0.5,15.8,0,14.5,0
            	c-2.4,0-4.3,1.9-4.3,4.3c0,0,0,0,0,0c0,0.3,0,0.7,0.1,1C6.8,5.1,3.6,3.5,1.5,0.9C1.1,1.5,0.9,2.2,0.9,3c0,1.5,0.8,2.8,1.9,3.6
            	C2.1,6.5,1.5,6.3,0.9,6v0c0,2.1,1.5,3.8,3.5,4.2c-0.4,0.1-0.8,0.1-1.1,0.1c-0.3,0-0.5,0-0.8-0.1c0.5,1.7,2.1,3,4,3
            	c-1.5,1.2-3.3,2-5.3,2c-0.3,0-0.7,0-1-0.1C1.9,16.5,4.2,17,6.6,17c7.9,0,12.2-6.6,12.2-12.2V4.2C19.7,3.6,20.4,2.9,21,2"/>
            </svg>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  var md = require("markdown-it")();
  var moment = require('moment');
  require('moment-timezone');
  var publishDate = moment("September 22, 2020 1:37:00").tz('America/New_York').format("MMM, D, YYYY, h:mm z");
  var updatedDate = moment("November 16, 2020 1:59:00").tz('America/New_York').format("MMM, D, YYYY, h:mm z");

  module.exports =  {
    name: 'top',
    data(){ return {
      publishDate: publishDate,
      updatedDate: updatedDate,
    } },
    props:['copy'],
    methods: {
      md: function(input) {
        return md.render(input);
      },
      mdInline: function(input) {
        return md.renderInline(input);
      }
    },
  }
</script>

<style scoped></style>
